export const _radioFr = {
    openRadio: 'Ouvrir la radio',
    initialisation: 'Initialisation',
    connected: 'Connectée au réseau',
    statusSent: 'Statut envoyé',
    statusReceived: 'Statut reçu',
    transmissionFailed: 'Echec de la transmission',
};

export const _radioEn = {
    openRadio: 'Open the radio',
    initialisation: 'Initialization',
    connected: 'Connected to the network',
    statusSent: 'Status sent',
    statusReceived: 'Status received',
    transmissionFailed: 'Transmission failed',
};

export const _radioDe = {
    openRadio: 'Radio öffnen',
    initialisation: 'Initialisierung',
    connected: 'Mit dem Netzwerk verbunden',
    statusSent: 'Status gesendet',
    statusReceived: 'Status erhalten',
    transmissionFailed: 'Übertragung fehlgeschlagen',
};
